import { createApi } from 'api/common/createApi'

export const colliderApi = createApi({
  baseURL: process.env.REACT_APP_COLLIDER_API_URL,
})

const normalizeBaseUrl = (value?: string): string => value?.replace(/\/+$/, '') ?? ''

const userAPI = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL)

export const api = createApi({
  baseURL: userAPI,
})
